export default __webpack_public_path__ + "static/media/the_bog_logo_xmas.33cb0d9b.png";